import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

function CategoryStepSlider() {
	if(!$('.js-category-step-slider').length) {
		return;
	}

	$('.js-category-step-slider').each(function(index) {
		let $this = $(this);
		let parentWrapper = $this.parents('.category-step-slides');
		parentWrapper.find('.category-step-slides__navigation').addClass('category-step-slides__navigation-' + index);
		parentWrapper.find('.category-step-slides__counter').addClass('category-step-slides__counter-' + index);
		$this.addClass('category-step-slider-' + index);

		let csSliderList = [];
		let $counterContainer = $(`.category-step-slides__counter-${index}`);

		let csSlider = new Swiper('.category-step-slider-' + index, {
			speed: 400,
			loop: false,
			simulateTouch: true,
			spaceBetween: 0,
			navigation:  {
				nextEl: `.category-step-slides__navigation-${index} .swiper-button-next`,
				prevEl: `.category-step-slides__navigation-${index} .swiper-button-prev`
			},

			on: {
				init: function (swiper) {
					$counterContainer.text(`${swiper.activeIndex + 1}/${swiper.slides.length}`)
				},
				slideChange: function (swiper) {
					$counterContainer.text(`${swiper.activeIndex + 1}/${swiper.slides.length}`);
				}
			}
		});

		csSliderList.push(csSlider);
		csSlider.init();
	});
}

export function init() {
	CategoryStepSlider();
}
